export default __webpack_public_path__ + "static/media/pants.e507ff6c.png";